// extracted by mini-css-extract-plugin
export default {"container":"Search_container__D07HD","icon":"Search_icon__UMxZJ"};